export default __webpack_public_path__ + "static/media/portolifo_right.a60a0e7e.svg";